import { css } from 'styled-components';

import font from './font';

export default css`
  width: 100%;
  height: 100%;
  color: #222222;
  ${font.body3};
  font-weight: 400;
  border: 0;
  background-color: transparent;
  
  &:disabled {
    color: #CCCCCC;
  }
`;
